import { SidebarBottomMenuWidget } from '@theia/core/lib/browser/shell/sidebar-bottom-menu-widget';
import type { SidebarMenu } from '@theia/core/lib/browser/shell/sidebar-menu-widget';
import { injectable } from '@theia/core/shared/inversify';

const THEIA_ACCOUNTS_MENU_ID: string = 'accounts-menu';

@injectable()
export class AppSidebarBottomMenuWidget extends SidebarBottomMenuWidget {
    override addMenu(menu: SidebarMenu): void {
        if (menu.id === THEIA_ACCOUNTS_MENU_ID) return;

        super.addMenu(menu);
    }
}
